import { get, getTrackingString } from '../../../utils/object-helpers';

export default function price(resp, variation, itemCard) {
    const binModel = variation ? get(variation, 'binModel', null) : get(resp, 'buyBox.binModel', null);
    const binPrice = get(binModel, 'price.textSpans.0.text', '');
    const strikeThrough = getStrikeThroughPrice(binModel);
    const percentOff = getPercentOffPrice(binModel);
    const baseUnitPrice = getBaseUnitPrice(binModel);
    const seePrice = getSeePrice(binModel, itemCard);
    let auctionPrice;
    let label;

    // If no bin price, then look for auction bid price and label
    if (!binPrice) {
        auctionPrice = get(resp, 'buyBox.bidPrice.textSpans.0.text', '');
        label = get(resp, 'buyBox.bidPriceLabel.textSpans.0.text', '');
    }

    return {
        text: binPrice || auctionPrice,
        label,
        strikeThrough,
        percentOff,
        baseUnitPrice,
        seePrice
    };
}

function getStrikeThroughPrice(binModel) {
    const addtlInfo = get(binModel, 'additionalInfo', []);
    const strikeThru = addtlInfo.find(info => {
        const textSpans = get(info, 'additionalText.textSpans', []);
        return !!textSpans.find(span => get(span, 'styles.0') === 'STRIKETHROUGH');
    });
    return get(strikeThru, 'additionalText.textSpans', null);
}

function getPercentOffPrice(binModel) {
    const addtlInfo = get(binModel, 'additionalInfo', []);
    const foundInfo = addtlInfo.find(info => {
        const textSpans = get(info, 'additionalText.textSpans', []);
        return !!textSpans.find(span => get(span, 'styles.0') === 'EMPHASIS');
    });
    return get(foundInfo, 'additionalText.textSpans', null);
}

function getBaseUnitPrice(binModel) {
    // We're assuming this is base unit price if it's the first "additionalInfo"
    // model and none of the textSpans contain style 'STRIKETHROUGH'.
    // The service model is ambiguous.
    const addtlInfo = get(binModel, 'additionalInfo', []);
    if (addtlInfo.length) {
        const textSpans = get(addtlInfo, '0.additionalText.textSpans', []);
        let foundStrikeThru;
        textSpans.forEach(span => {
            if (span.styles) {
                span.styles.forEach(style => {
                    if (style === 'STRIKETHROUGH') {
                        foundStrikeThru = true;
                    }
                });
            }
        });

        if (!foundStrikeThru) {
            return get(addtlInfo, '0.additionalText.textSpans.0.text', '');
        }
    }
}

function getSeePrice(binModel, itemCard) {
    const seePrice = get(binModel, 'seePrice', null);
    const text = get(itemCard, 'displayPrice.textSpans.0.text', '');
    const altText = get(itemCard, 'displayPrice.textSpans.0.accessibilityText', '');
    const url = get(itemCard, 'displayPrice.action.URL', '');
    const tracking = getTrackingString(itemCard, 'displayPrice.action.trackingList');

    if (seePrice && text && url) {
        return {
            text,
            altText,
            url,
            tracking
        };
    }
}
